import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";

import { useCampaignContext } from "../context/CampaignContext";

import type { CancelledTarget } from "../types";

async function getCancelledAudienceRequest(
  workspaceId: string,
  campaignId: string,
): Promise<CancelledTarget[]> {
  return (
    await get(`workspaces/${workspaceId}/campaigns/${campaignId}/cancelled`)
  ).targets;
}

export default function useCancelledAudience() {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { id: campaignId } = useCampaignContext();

  const { campaignsKeys } = getQueryKeys(workspaceId);

  const {
    data: cancelledAudience,
    isLoading: isLoadingCancelledAudience,
    isError: isCancelledAudienceError,
    refetch: refetchCancelledAudience,
  } = useQuery({
    queryKey: campaignsKeys.cancelledAudience(campaignId),
    queryFn: () => getCancelledAudienceRequest(workspaceId, campaignId),
  });

  return {
    cancelledAudience,
    isLoadingCancelledAudience,
    isCancelledAudienceError,
    refetchCancelledAudience,
  };
}
